import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { isNotNull } from "../helper/functions";


function novaLista(nome, descricao, dfault = false) {
    return {
        id: uuidv4(),
        dataCriacao: new Date().toString(),
        nome: nome,
        descricao: descricao,
        dataCancelamento: null,
        default: dfault,
        todos: []
    }
}

function novaListaForm() {
    return {
        nome: "",
        descricao: "",
        default: false,
        isOpen: false,
    }
}

function novoTodoForm() {
    return {
        id: uuidv4(),
        titulo: "",
        dataConclusao: null,
        ordem: 0
    }
}

const initialState = {
    selectedListaId: null,
    listas: [],
    listaDraggable: {
        startIndex: null,
        endIndex: null,
    },
    novaListaForm: novaListaForm(),
    novoTodoForm: novoTodoForm(),
    todoEditForm: null
}

export const todosSlice = createSlice({
    name: "todos",
    initialState,
    reducers: {
        startDrag: (state, action) => {
            state.listaDraggable.startIndex = action.payload
            // console.log(state.listaDraggable.startIndex)
        },
        updateDragOver: (state, action) => {
            state.listaDraggable.endIndex = action.payload
            // console.log(state.listaDraggable.endIndex)
        },
        endDrag: (state) => {

            var startIndex = state.listaDraggable.startIndex
            var endIndex = state.listaDraggable.endIndex

            if (startIndex != null && endIndex != null && startIndex != endIndex) {
                // console.log("Reordenando")

                var listaIndex = state.listas.indexOf(state.listas.filter( e => e.id == state.selectedListaId)[0])

                var t = [...state.listas[listaIndex].todos]

                var start = t[startIndex]

                t.splice(startIndex, 1)
                t.splice(endIndex, 0, start)
                state.listas[listaIndex].todos = t
            }

            state.listaDraggable.startIndex = null
            state.listaDraggable.endIndex = null
        },
        setSelectedListaById: (state, action) => {
            state.selectedListaId = action.payload
        },
        setNovaListFormAttr: (state, action) => {
            state.novaListaForm[action.payload.campo] = action.payload.value
        },
        addNovaListaParaListas: (state) => {
            var lista = novaLista(
                state.novaListaForm.nome,
                state.novaListaForm.descricao,
                state.novaListaForm.default)

            var listas = [...state.listas]

            if (lista.default == true)
                listas.forEach(e => e.default = false)

            listas.push(lista)

            state.listas = listas
            state.novaListaForm = novaListaForm()
            state.selectedListaId = lista.id
        },
        carregaLista: (state, action) => {
            state.listas = action.payload
        },
        removerLista: (state, action) => {
            var l = [...state.listas]
            l.splice(state.listas.indexOf(state.listas.filter(e => e.id == action.payload)[0]), 1)

            state.listas = l
            state.selectedListaId = null
        },
        setNovoTodoFormAttr: (state, action) => {
            state.novoTodoForm[action.payload.campo] = action.payload.value
        },
        addNovoTodoParaTodos: (state) => {
            var lista = state.listas.filter(e => e.id == state.selectedListaId)[0]

            var todos = [state.novoTodoForm, ...lista.todos]

            // todos.push(state.novoTodoForm)
            // console.log(state.novoTodoForm)

            state.novoTodoForm = novoTodoForm()

            lista.todos = todos
        },
        toggleTodoConlusao: (state, action) => {
            var lista = state.listas.filter(e => e.id == state.selectedListaId)[0]

            var todos = [...lista.todos]

            var t = action.payload

            todos.filter(e => e.id == t.id)[0].dataConclusao = t.dataConclusao != null ? null : new Date().toString()

            lista.todos = todos
        },
        removeTodo: (state, action) => {
            var lista = state.listas.filter(e => e.id == state.selectedListaId)[0]

            var todos = [...lista.todos]

            var id = action.payload

            todos = todos.filter(e => e.id != id)

            lista.todos = todos
        },
        setEditTodo: (state, action) => {
            if (action.payload == null)
                state.todoEditForm = null
            else
                state.todoEditForm = {
                    id: action.payload.id,
                    titulo: action.payload.titulo
                }
        },
        setEditTodoFormAttr: (state, action) => {
            state.todoEditForm[action.payload.campo] = action.payload.value
        },
        salvarEditTodo: (state) => {
            var lista = state.listas.filter(e => e.id == state.selectedListaId)[0]

            lista.todos.filter(e => e.id == state.todoEditForm.id)[0].titulo = state.todoEditForm.titulo
        },
        toggleDefault: (state) => {
            var listas = [...state.listas]

            var l = listas.filter(e => e.id == state.selectedListaId)[0]
            if (isNotNull(l)) {
                l.default = !l.default
            }

            listas.filter(e => e.id != state.selectedListaId)
                .forEach(x => x.default = false)

            state.listas = listas
        }
    }
})

export const {
    setSelectedListaById,
    setNovaListFormAttr,
    addNovaListaParaListas,
    carregaLista,
    removerLista,
    setNovoTodoFormAttr,
    addNovoTodoParaTodos,
    toggleTodoConlusao,
    removeTodo,
    setEditTodo,
    setEditTodoFormAttr,
    salvarEditTodo,
    toggleDefault,
    startDrag,
    updateDragOver,
    endDrag
} = todosSlice.actions

export default todosSlice.reducer;